const numberGenerator = (min, max) => {
  return Math.floor(Math.random() * max) + min;
};

export default numberGenerator;
